import { useState } from 'react';

import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { RecordContextProvider } from 'react-admin';
import { Box } from 'shared/mui/Box';
import { CardHeader } from 'shared/mui/Card/CardHeader/CardHeader';
import { Dialog, DialogProps } from 'shared/mui/Dialogs';
import { CloseIconButton } from 'shared/mui/IconButtons';
import { GatewaysShowChipFields } from 'shared/widgets/GatewayShow/GatewayShowChipFields/GatewayShowChipFields';
import { GatewaysShowSkeleton } from 'shared/widgets/GatewayShow/GatewaysShowSkeleton/GatewaysShowSkeleton';
import { GatewaysShowTable } from 'shared/widgets/GatewayShow/GatewaysShowTable/GatewaysShowTable';
import { Gateway } from 'types/embedded/gateway';

export type GatewayShowDialog = {
  gateway?: Gateway;
  onClose: () => void;
  isFetching?: boolean;
} & DialogProps;

export const GatewayShowDialog: React.FC<GatewayShowDialog> = ({
  open,
  gateway,
  onClose,
  isFetching,
}) => {
  const translate = useTypedTranslate();

  const [visible, setVisible] = useState('visible');

  return (
    <Dialog maxWidth="md" onClose={onClose} open={open} sx={{ visibility: visible }}>
      <Box
        sx={{ display: 'flex', top: '50%', flexDirection: 'column', padding: 0, width: '640px' }}
      >
        <CardHeader
          appendActions={[<CloseIconButton key="close-button" onClose={onClose} />]}
          title={translate('app.gateway.gatewayView')}
          titleSize="smallBold"
        />
        <Box m={3}>
          {!isFetching ? (
            <RecordContextProvider value={gateway}>
              <GatewaysShowChipFields
                onProviderClose={() => setVisible('visible')}
                onProviderOpen={() => setVisible('hidden')}
              />
              <GatewaysShowTable />
            </RecordContextProvider>
          ) : (
            <GatewaysShowSkeleton />
          )}
        </Box>
      </Box>
    </Dialog>
  );
};
